// polyfills - begin
if (!Array.isArray)
{
    Array.isArray = function(arg)
    {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}
// polyfills - end

var orion = {
    'classHidden': 'hidden',

    'map': function(list, f)
    {
        var
            i, l,
            result;

        if (Array.isArray(list))
        {
            result = [];
            for (i = 0, l = list.length; i < l; i += 1)
            {
                result[i] = f(list[i]);
            }
        }
        else
        {
            // assume list is an object hash
            result = {};
            for (i in list)
            {
                if (Object.prototype.hasOwnProperty.call(list, i))
                {
                    result[i] = f(list[i]);
                }
            }
        }

        return result;
    },

    'resetPaginationParameters': function(q)
    {
        var elementsPerPage = $('meta[name=elementsPerPage]').attr('content') || orion.constants.ElementsPerPage;

        return q.replace(/^(.*)--[0-9]+--[0-9]+(--.*)$/, '$1--0--' + elementsPerPage + '$2');
    },

    'toPageCategory': function()
    {
        return $('meta[name=pageCategory]').attr('content');
    },

    'getShopViewCode': function()
    {
        return $('meta[name=shop_view_code]').attr('content');
    },

    'getShopId': function()
    {
        return $('meta[name=shop_id]').attr('content');
    },

    'getShopProfileCode': function()
    {
        return $('meta[name=shop_profile_code]').attr('content');
    },

    'getDefaultShoppingListId': function()
    {
        return $('meta[name=default_shopping_list_id]').attr('content');
    },

    'getLocaleCode': function()
    {
        return $('meta[name=localeCode]').attr('content');
    },

    'getCustomerId': function()
    {
        return $('meta[name=customer_id]').attr('content');
    },

    'constants': {
        'ClassBasketUpdated': 'basket-updated',
        'ClassProcessing': 'processing',
        'ElementsPerPage': 24,
        'EventAgeConfirmed': 'age-confirmed',
        'EventCartUpdated': 'cart-updated',
        'EventCartProductCreated': 'cart-product-created',
        'EventCartProductDeleted': 'cart-product-deleted',
        'EventCartProductUpdated': 'cart-product-updated',
        'EventCsvDownloadButtonAppended': 'csv-download-button-appended',
        'EventDefaultShoppingListChanged': 'default-shopping-list-changed',
        'EventDropdownOpened': 'dropdown-opened',
        'EventFeedbackAdded': 'feedback-added',
        'EventFiltersChanged': 'filters-changed',
        'EventFilterMarkupAppended': 'filters-markup-appended',
        'EventFiltersMarkupReplaced': 'filters-markup-replaced',
        'EventFocusOverlayClicked': 'focus-overlay-clicked',
        'EventFolddownClosed': 'folddown-closed',
        'EventFolddownMobileOpening': 'folddown-mobile-opening',
        'EventFolddownOpened': 'folddown-opened',
        'EventFolddownRequested': 'folddown-requested',
        'EventFoldupRequested': 'foldup-requested',
        'EventFormValidate': 'form-validate',
        'EventFormValidationComplete': 'form-validation-complete',
        'EventFormInitNext': 'form-init-next',
        'EventHoverviewMouseenter': 'hoverview-mouseenter',
        'EventHoverviewMouseleave': 'hoverview-mouseleave',
        'EventModalAppended': 'modal-appended',
        'EventModalClosed': 'modal-closed',
        'EventModalOpened': 'modal-opened',
        'EventNavigatingToIndex': 'navigating-to-index',
        'EventNavigationAppended': 'navigation-appended',
        'EventOverlayClosed': 'overlay-closed',
        'EventOverlayOpened': 'overlay-opened',
        'EventProductImageUpdated': 'product-image-updated',
        'EventProductListReloaded': 'product-list-reloaded',
        'EventQChanged': 'q-changed',
        'EventRequestNavigateToIndex': 'request-navigate-to-index',
        'EventReset': 'orion.reset',
        'EventShoppingListProductCreated': 'shoppinglist-product-created',
        'EventShoppingListProductDeleted': 'shoppinglist-product-deleted',
        'EventShoppingListProductUpdated': 'shoppinglist-product-updated',
        'EventShoppingListDefaultUpdated': 'shoppinglist-default-updated',
        'EventOrderlistItemLoaded': 'orderlist-item-loaded',
        'EventSortCriteriumChanged': 'sort-criterium-changed',
        'EventTabOpened': 'tab-opened',
        'EventTilesviewVariationChanged': 'tilesview-variation-changed',
        'EventValidationFailedOnSubmit': 'validation-failed-on-submit',
        'EventValidationParametersChanged': 'validation-parameters-changed',
        'EventWizardGoto': 'wizard-goto',
        'EventWizardStepNextBefore': 'wizard-step-next-before',
        'EventWizardStepNextAfter': 'wizard-step-next-after',
        'EventWizardStepPrevBefore': 'wizard-step-prev-before',
        'EventWizardStepPrevAfter': 'wizard-step-prev-after',
        'EventProductImageIndexChanged': 'product-image-index-changed',
        'EventProductImageLoad360Image': 'load360'
    }
};
